articleFeaturedProducts();

function articleFeaturedProducts() {
  const productsBlock = document.querySelector(".article-pairings");
  if (productsBlock) {
    const article = document.querySelector(".article-text");
    const order = parseInt(productsBlock.dataset.order);

    if (order) {
      try {
        article.children[order].before(productsBlock);
      } catch {
        console.log("Order too high!");
      }
    }
    productsBlock.style.setProperty(
      "--height",
      productsBlock.firstElementChild.scrollHeight + "px"
    );
  }
}
